// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DataSourcePieChart from './DataSourcesPieChart';
import FormattedGB from '../common/FormattedGB';
import { FormattedNumber } from 'react-intl';
// css
import '../../styles/components/analytics/DataSourcesByArea.scss';
import defaultColors from '../../constants/dataSourcesColors';


class DataSourcesByArea extends Component {

  getOverviewPieChartData() {
    return this.props.stats.map(area => (
      {
        title: area.area.title,
        value: parseFloat(area.stats.dataRequired),
        active: area.area.active
      }
    ));
  }

  getAreaTitle(index) {
    return this.props.stats[index].area.title;
  }

  isAreaActive(index) {
    return this.props.stats[index].area.active;
  }

  getAreaPieChartData(index) {
    const subareas = this.props.stats[index].subareas;

    return subareas.map(subarea => (
      {
        title: subarea.subarea.title,
        value: parseFloat(subarea.stats.dataRequired),
        active: true
      }
    ));
  }

  getAreaPieChartProps(index) {
    const { stats } = this.props;
    return {
      title: this.getAreaTitle(index),
      active: this.isAreaActive(index),
      data: this.getAreaPieChartData(index),
      colors: this.props.colors,
      labelFontSize: this.props.chartLabelFontSize / 2,
      nonCiscoDataPerDay: stats[index].stats.nonCiscoDataPerDay || 0,
      ciscoDataPerDay: stats[index].stats.ciscoDataPerDay || 0
    };
  }

  getTotalCiscoStat(field) {
    return this.props.stats.reduce((sum, area) => (
      area.area.active ? sum + (area.stats[field] || 0) : sum
    ), 0);
  }

  render() {
    const { pptxTarget, totalDataPerDay, chartLabelFontSize } = this.props;
    const totalNonCisco = this.getTotalCiscoStat('nonCiscoDataPerDay');
    const totalCisco = this.getTotalCiscoStat('ciscoDataPerDay');

    return (
      <div
        id={pptxTarget}
        className='analytics__data-sources-by-area'
      >
        <h2>Data Sources By Area</h2>
        <h3>
          <span className='analytics__data-sources-by-area__total'>
            <FormattedGB value={totalDataPerDay} perDay />
          </span>
          (based on key data sources identified by participants and required to achieve key goals)
        </h3>
        <div className='analytics__data-sources-by-area__cisco-split'>
          <FormattedNumber value={totalNonCisco} maximumFractionDigits={1} /> GB/day Non Cisco
          {' · '}
          <FormattedNumber value={totalCisco} maximumFractionDigits={1} /> GB/day Cisco Data
        </div>

        <div className='row'>
          <div className='col-md-4'>
            <div className='analytics__data-sources-by-area__overview-chart'>
              <DataSourcePieChart
                data={this.getOverviewPieChartData()}
                labelFontSize={chartLabelFontSize}
                legendPos='bottom'
                colors={this.props.colors}
              />
            </div>
          </div>
          <div className='col-md-8'>
            <div className='analytics__data-sources-by-area__area-charts'>
              <div className='row'>
                <div className='col-md-6'>
                  <DataSourcePieChart {...this.getAreaPieChartProps(0)} />
                </div>
                <div className='col-md-6'>
                  <DataSourcePieChart {...this.getAreaPieChartProps(1)} />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-6'>
                  <DataSourcePieChart {...this.getAreaPieChartProps(2)} />
                </div>
                <div className='col-md-6'>
                  <DataSourcePieChart {...this.getAreaPieChartProps(3)} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

DataSourcesByArea.defaultProps = {
  colors: defaultColors,
  chartLabelFontSize: 48
};

DataSourcesByArea.propTypes = {
  stats: PropTypes.array.isRequired,
  totalDataPerDay: PropTypes.number.isRequired,
  pptxTarget: PropTypes.string,
  colors: PropTypes.array,
  chartLabelFontSize: PropTypes.number
};

export default DataSourcesByArea;



// WEBPACK FOOTER //
// ./src/components/analytics/DataSourcesByArea.js